import React from 'react';
import { QueryClient, QueryClientProvider } from 'react-query';

import Paywall from '@components/Paywall';
import { AppContextProvider } from '@contexts/AppContext';
import useServerSideRendering from '@hooks/useServerSideRendering';

import { ArticleProps } from '../Article/interfaces';

const PaywallPage = (props: ArticleProps): JSX.Element => {
  const hydrated = useServerSideRendering();
  return (
    <AppContextProvider
      env={props.env}
      initialCurrentUser={props.initialCurrentUser}
      isGdprRequired={props.isGdprRequired}
      isWebview={props.isWebview}
    >
      <QueryClientProvider client={new QueryClient()}>
        {hydrated && <Paywall {...props.paywallProps} />}
      </QueryClientProvider>
    </AppContextProvider>
  );
};

export default PaywallPage;
